import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type CreateLooseCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateLooseCargoItemInput;
}>;

export type CreateLooseCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoCreateLooseCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'CreateLooseCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<GraphQLTypes.CargoContainerType, 'id'>)
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<GraphQLTypes.CargoLooseCargoType, 'id'>)
        | ({ __typename?: 'CargoVehicleType' } & Pick<GraphQLTypes.CargoVehicleType, 'id'>)
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateLooseCargoItemDocument = gql`
  mutation createLooseCargoItem($input: CreateLooseCargoItemInput!) {
    cargoCreateLooseCargoItem(input: $input) {
      cargoItem {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
